import React, { useState } from 'react'
import Modal from '@mui/material/Modal'
import { useHistory } from 'react-router-dom'
import { useAuth } from '../../auth/Auth'
import { useCookies } from 'react-cookie'
import { useData } from '../../data/DataProvider'
import { GpButton } from '../../components/gp'

export default function LogoutModal(props) {
    const [isLoading, setIsLoading] = useState(false)
    const [, , removeCookie] = useCookies(['propertyUuid', 'inviteUuid', 'inviteRole'])

    const history = useHistory()
    const auth = useAuth()
    const data = useData()

    const logOut = async () => {
        setIsLoading(true)
        try {
            auth.signout().then(() => {
                setIsLoading(false)
                props.handleClose()
                if (data.isSetupComplete) {
                    removeCookie('propertyUuid', { path: '/' })
                    removeCookie('inviteUuid', { path: '/' })
                    removeCookie('inviteRole', { path: '/' })
                }
                history.push('/sign-in')
            })
        } catch (error) {
            setIsLoading(false)
        }
    }

    return (
        <Modal open={props.open} onClose={props.handleClose} aria-labelledby="logout-title">
            <div
                style={{
                    position: 'fixed',
                    inset: 0,
                    background: 'rgba(11, 41, 38, 0.45)',
                    backdropFilter: 'blur(2px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: 24,
                }}
                onMouseDown={(e) => {
                    if (e.target === e.currentTarget) props.handleClose()
                }}
            >
                <div
                    style={{
                        background: 'var(--gp-card)',
                        borderRadius: 'var(--gp-r-xl)',
                        width: '100%',
                        maxWidth: 420,
                        boxShadow: '0 20px 60px rgba(11, 41, 38, 0.25)',
                        padding: '28px 28px 24px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 22,
                        outline: 'none',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
                        <div
                            style={{
                                width: 44,
                                height: 44,
                                borderRadius: 12,
                                background: 'var(--gp-lime-soft)',
                                color: 'var(--gp-brand)',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                            }}
                        >
                            <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="1.75"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                <polyline points="16 17 21 12 16 7" />
                                <line x1="21" y1="12" x2="9" y2="12" />
                            </svg>
                        </div>
                        <div style={{ flex: 1, paddingTop: 4 }}>
                            <h2
                                id="logout-title"
                                style={{
                                    margin: 0,
                                    font: '500 18px/1.25 var(--gp-font)',
                                    color: 'var(--gp-ink)',
                                }}
                            >
                                Sign Out of GoPower?
                            </h2>
                            <p
                                style={{
                                    margin: '6px 0 0',
                                    font: 'var(--gp-caption)',
                                    color: 'var(--gp-ink-mute)',
                                }}
                            >
                                You'll need to sign back in to view your charging sessions, balance and property.
                            </p>
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                        <GpButton variant="ghost" onClick={props.handleClose} disabled={isLoading}>
                            Stay Signed In
                        </GpButton>
                        <GpButton
                            variant="primary"
                            onClick={logOut}
                            disabled={isLoading}
                            data-testid="cypress-logout-confirm-button"
                        >
                            {isLoading ? 'Signing out…' : 'Sign Out'}
                        </GpButton>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
